import React from 'react';

export default function Icon({ name }) {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (name) {
    case 'calendar':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><rect x="3" y="4" width="18" height="18" rx="3" {...common} /><path d="M16 2v4M8 2v4M3 10h18" {...common} /></svg>;
    case 'timeline':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><path d="M5 7h6M5 12h10M5 17h14" {...common} /><circle cx="18" cy="12" r="2" {...common} /></svg>;
    case 'plus':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><path d="M12 5v14M5 12h14" {...common} /></svg>;
    case 'chevL':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><path d="M15 18l-6-6 6-6" {...common} /></svg>;
    case 'chevR':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><path d="M9 18l6-6-6-6" {...common} /></svg>;
    case 'search':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><circle cx="11" cy="11" r="7" {...common} /><path d="M20 20l-3.5-3.5" {...common} /></svg>;
    case 'filter':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><path d="M4 5h16l-6 7v6l-4 2v-8L4 5z" {...common} /></svg>;
    case 'x':
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><path d="M18 6L6 18M6 6l12 12" {...common} /></svg>;
    case 'dot':
      return <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden><circle cx="12" cy="12" r="6" {...common} /></svg>;
    default:
      return <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden><path d="M12 12h.01" {...common} /></svg>;
  }
}
